import React from "react";
import { COMPANY } from "../data/constants";

/**
 * BrandWordmark — stacked "SHOOLIN / DIGITAL SERVICES" in Anton condensed.
 * Used in the hero and footer. The header uses the smaller hex logo instead.
 */
export default function BrandWordmark({
  size = "md",
  align = "left",
  className = "",
  "data-testid": testId = "brand-wordmark",
}) {
  const sizeMap = {
    sm: "text-3xl sm:text-4xl",
    md: "text-5xl sm:text-6xl md:text-7xl",
    lg: "text-6xl sm:text-7xl md:text-8xl lg:text-9xl",
    xl: "text-7xl sm:text-8xl md:text-[9rem] lg:text-[11rem]",
  };
  const alignClass = align === "center" ? "items-center text-center" : "items-start text-left";

  return (
    <div
      data-testid={testId}
      className={`font-condensed wordmark-stack flex flex-col ${alignClass} ${className}`}
    >
      <span className={`${sizeMap[size]} text-white leading-[0.82]`}>SHOOLIN</span>
      <span className={`${sizeMap[size]} text-[#F47B20] leading-[0.82]`}>DIGITAL SERVICES</span>
    </div>
  );
}

export function BrandHexLogo({ size = 36, className = "", alt = COMPANY.name }) {
  return (
    <img
      src={COMPANY.logo}
      alt={alt}
      width={size}
      height={size}
      style={{ width: size, height: size }}
      className={`block ${className}`}
      loading="eager"
      decoding="async"
    />
  );
}
